import {UIPlayerColorController} from '../../UIPlayerColorController'
import {Sound} from '../../Sound'
import {SocketLobbySend} from '../../socket/SocketLobbySend'
import {ClientUserState} from '../../ClientUserState'
import {RoomSessionClientState} from '../../../../../shared/RoomSessionClientState'
import {PlayerColor} from '@colonist/game-states'

export class UIRoomPlayerColorController extends UIPlayerColorController {
    private player: RoomSessionClientState | undefined

    constructor() {
        super()
        this.colorSelectionModal = document.getElementById('room_colorselector_modal') as HTMLDivElement
        this.colorsContainer = document.getElementById('room_colorselector_container') as HTMLDivElement
        this.colorsGrid = document.getElementById('room_colorselector_grid') as HTMLDivElement

        this.colorSelectionModal.onclick = (event: MouseEvent) => {
            if(event.target === this.colorSelectionModal) this.hideColorWindow()
        }
        this.setCloseButton()

        void this.update()
    }

    async update() {
        const userState = ClientUserState.userState
        this.setState({
            activeColor: userState?.preferredColor,
            availableColors: userState?.items.getAvailableColors() ?? [],
        })
    }

    openColorWindowForPlayer(selectedPlayer: RoomSessionClientState | undefined) {
        this.player = selectedPlayer
        if(this.player != undefined) {
            this.setState({
                activeColor: this.player.selectedColor,
                availableColors: this.player.availableColors,
            })
        }
        this.showColorWindow()
    }

    protected onColorSelect(color: PlayerColor) {
        Sound.playSound(Sound.SoundType.Click)
        this.hideColorWindow()
        this.updatePreferredColor(color)
    }

    protected updatePreferredColor(color: PlayerColor) {
        if(this.player == undefined) return
        SocketLobbySend.clickedRoomSelectColor(this.player.roomSessionId, color)
    }

    protected override isColorActive(color: PlayerColor): boolean {
        return color == this.player?.selectedColor
    }

    private setCloseButton() {
        const selectorCloseButton = document.getElementById('room_colorselector_close') as HTMLDivElement
        selectorCloseButton.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            this.hideColorWindow()
        }
    }
}
